import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { BaseApiService } from '../../../@core/api/base-api.service';
import { ConfigService } from '../../../@shared/services/config.service';
import { HttpClient } from '@angular/common/http';
import { LicenseplateSettings } from './licenseplate-settings.model';

@Injectable({
  providedIn: 'root',
})
export class LicenseplateSettingsService extends BaseApiService {
  private apiUrl = '';

  constructor(
    configService: ConfigService,
    httpClient: HttpClient,
    private toastrService: NbToastrService
  ) {
    super(configService, httpClient);
    this.apiUrl = this.parkbaseBl9BaseUrl + '/settings/lpr';
  }

  getSettings() {
    return this.http.get<LicenseplateSettings>(this.apiUrl, { headers: this.setHeaders() });
  }

  saveSettings(data: LicenseplateSettings) {
    return this.http.post<LicenseplateSettings>(this.apiUrl, data, { headers: this.setHeaders() });
  }
}
